<div class="unauthorized-page">
  <div class="text-center">
    <div class="error-icon mb-4">
      <i class="bi bi-shield-exclamation"></i>
    </div>
    <h1 class="display-4 mb-3">Access Denied</h1>
    <p class="lead text-muted mb-4">
      You don't have permission to access this page.
    </p>
    <a routerLink="/dashboard" class="btn btn-primary">
      <i class="bi bi-house me-2"></i>
      Back to Dashboard
    </a>
  </div>
</div>
